import React from "react"
import AiAnalyseComponent from "../../components/Analysis/ai"

const AinsteinPage = () => {
  return (
    <AiAnalyseComponent />
  )
}

export default AinsteinPage